export class WorkflowVisualization {         
    Xaxis: number;
    Yaxis: number;    
    Uuid: string;

    constructor(xaxis:number, yaxis: number, uuid: string){
        this.Xaxis = xaxis;
        this.Yaxis = yaxis;        
        this.Uuid = uuid;
    }

}



